import JSONAPIAdapter from '@ember-data/adapter/json-api'

export default class ApplicationJSONAPIAdapter extends JSONAPIAdapter {}
